<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div
        class="container">
        <grid-row
          column-align="center">
          <grid-col
            col-size="4">
            <h1
              class="header margin-top-xl">
              <div>
                <chevron
                  @click="$router.push({name: 'VariableManagement'})"/>
                {{ $t('variableManagement.categoricalVariables') }}
              </div>
              <div class="btn-pill-wrapper">
                <div v-has-feature="'Admin'">
                    <font-awesome-icon class="header-add-rule-icon opacity"
                     @click="$router.push({name: 'VariableCategory'})"
                    :icon="icon.add" />
                </div>
              </div>
            </h1>
            <alert
              v-if="alertVisible"
              :message="alertMessage"
              :type="alertType">
            </alert>
          </grid-col>
        </grid-row>
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <categorized-variable-table
              :data="getVariableValues"
              :variables-minimal="getVariablesMinimal"
              v-on:onEdit="onEdit"
              v-on:onDelete="onDelete"/>
          </grid-col>
        </grid-row>
      </div>
      <ok-cancel-modal
        v-if="showConfirmationDeleteModal"
        v-on:ok="onDeleteConfirm"
        v-on:cancel="onDeleteCancel"
        :title="deleteModalMessage"
        :message="deleteModalMessage"
        :okButton="$t('commons.delete')"
        :cancelButton="$t('commons.cancel')">
        <div slot="body">
          <ul>
            <li>
              {{ deletingCategory.name }}
            </li>
          </ul>
        </div>
      </ok-cancel-modal>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '../MainLayout';
import Chevron from '@/components/shared/Chevron';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import {mapActions, mapGetters} from 'vuex';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import Tags from '@/components/variable/Tags';
import BtnPill from '@/components/shared/buttons/BtnPill';
import Alert from '@/components/shared/alert/Alert';
import CategorizedVariableTable from '@/components/variable/CategorizedVariableTable';
import {faPlusCircle} from '@fortawesome/pro-solid-svg-icons';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import variableApi from '@/api/variable';

export default {
  name: 'VariableCategoryList',
  components: {
    MainLayout,
    Chevron,
    GridRow,
    GridCol,
    TableComponent,
    TableColumn,
    FontAwesomeIcon,
    Tags,
    BtnPill,
    Alert,
    CategorizedVariableTable,
    OkCancelModal
  },
  data () {
    return {
      deletingCategory: -1,
      showConfirmationDeleteModal: false,
      deleteModalMessage: '',
      icon: {
        add: faPlusCircle
      },
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      },
      tablePageSize: 10,
      alertVisible: false,
      alertMessage: '',
      alertType: '', // error, warning, success
      variablesMinimal: []
    };
  },
  created () {
    variableApi.getMinimalVariables(this).then(data => {
      this.variablesMinimal = data.body.sort((a, b) => {
        return a.label.localeCompare(b.label, undefined, {numeric: true, sensitivity: 'base'});
      });
    });
    this.retrieveCategories({ context: this });

    const alert = this.$route.params.alert;
    if (alert !== undefined) {
      showAlert(this, this.$t(alert), 'success');
    }
  },
  computed: {
    ...mapGetters([
      'getCategories'
    ]),
    getBreadcrumb () {
      return [
        { name: this.$t('menu.workspace'), link: '/workspace' },
        { name: this.$t('variableManagement.title'), link: '/variable-management' },
        { name: this.$t('variableManagement.categoricalVariables'), link: '/categorical-variable/list', disabled: true }
      ];
    },
    getVariableValues () {
      return this.getCategories;
    },
    getVariablesMinimal () {
      return this.variablesMinimal;
    }
  },
  methods: {
    ...mapActions([
      'retrieveCategories',
      'deleteCategory'
    ]),
    onEdit (category) {
      this.$router.push({name: 'VariableCategory', params: category, query: {origin: 'VariableCategoryList'}});
    },
    onDelete (category) {
      this.deletingCategory = category;
      this.deleteModalMessage = this.$t('variableManagement.deleteModalMessage');
      this.showConfirmationDeleteModal = true;
    },
    onDeleteConfirm () {
      const id = this.deletingCategory.id;
      const categoryName = this.deletingCategory.name;
      this.deletingRule = {};
      this.showConfirmationDeleteModal = false;
      this.deleteCategory({ context: this, id: id }).then(() => {
        showAlert(this, this.$t('variableManagement.successDelete', {name: categoryName}), 'success');
      }, () => {
        showAlert(this, this.$t('variableManagement.errorDelete', {name: categoryName}), 'error');
      });
    },
    onDeleteCancel () {
      this.deletingCategory = {};
      this.showConfirmationDeleteModal = false;
    }
  }
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2000);
};
</script>

<style lang="scss" scoped>
  @import "src/stylesheets/variables";

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header-add-rule-icon {
    font-size: 3rem;
    color: $secondary;
  }

  .btn-pill-wrapper {
    display: flex;
    align-items: center;
  }

  .opacity:hover {
    cursor: pointer;
    opacity: 0.3;
    transition: opacity 0.3s;
  }

</style>



// WEBPACK FOOTER //
// src/layouts/variables/VariableCategoryList.vue